import { observer } from 'mobx-react-lite'
import { Scrollbar } from 'shared/ui'
import { PresetContainer, PresetInfo, PresetList, PresetListItem } from 'shared/Preset'
import { TemplateConfigList } from 'pages/workflows/ui/CreateWorkflowModal/config'
import { type ICreateWorkflowProps } from 'pages/workflows/ui/CreateWorkflowModal/types/types'

export const WorkflowTemplateModal = observer(({ workflow, onNext }: ICreateWorkflowProps) => (
  <PresetContainer>
    <PresetInfo name='You can select one template' />
    <Scrollbar autoHeight autoHeightMax={302}>
      <PresetList>
        {TemplateConfigList.map((template) => (
          <PresetListItem
            key={template.name}
            disabled={template.disabled}
            onClick={() => {
              workflow.setTemplateName(template.name)
              onNext()
            }}
            icon={template.icon}
            name={template.name}
            description={template.description}
          />
        ))}
      </PresetList>
    </Scrollbar>
  </PresetContainer>
))
